/**
 * Image Loader
 *
 * This class wraps the jquery fileupload plugin which allows for drag and drop
 * as well as regular file uploads. Attempts to load files locally to be displayed
 * but falls back to server uploads.
 *
 * TODO(mattjs) Investigate multi file uploads and perhaps restrict to 1 file
 * TODO(mattjs) Make this module use templating so it can be used more than once
 * on the page
 *
 * @author mattjs@yext.com
 */
goog.provide('yext.imageloader');

goog.require('yext');
goog.require('yext.dialog');
goog.require('yext.fileupload');
goog.require('yext.image');
goog.require('yext.image.Constraints');

var {Spinner} = /** @type {SpinnerJS} */ (require('spin.js'));
require('spin.js/spin.css');

yext.imageloader.events = {};

yext.imageloader.externalImageUrlTimeout = 2000;
yext.imageloader.externalImageUrlEndpoint = '';
yext.imageloader.fetchImageXhr = false;
yext.imageloader.fetchImageByUrlMutex = false;

yext.imageloader.defaultOptions = {
  constraints: {
    maxFileSize: 5, // MB
    minFileSize: 0, // Bytes
  },
  acceptedFileTypes: /^image(\.|\/)(gif|jpe?g|png|bmp|tiff|webp?)$/i,
  badFileTypeMsg: yext.msg('Unrecognized file format. Please select a JPG, PNG, BMP, TIFF, GIF or WEBP.'),
};

/**
 * @constructor
 *
 * @param {!Object} options Override default options if needed
 */
yext.imageloader.init = function(options) {
  yext.imageloader.options = $.extend(true, {}, yext.imageloader.defaultOptions, options);

  yext.imageloader.$container = $('.js-image-loader');

  if (yext.imageloader.$container.length === 0) {
    return;
  }

  yext.imageloader.$dropArea = yext.imageloader.$container.find('.js-drop-area');
  yext.imageloader.$dropImageIcon = yext.imageloader.$dropArea.find('.js-drop-image-icon');
  yext.imageloader.$dropAreaMessage = yext.imageloader.$dropArea.find('.js-drop-area-message');
  yext.imageloader.$selectFileOrUrl = yext.imageloader.$container.find('.js-select-file-or-url');
  // There can be up to two of each of $selectAFile and $enterAUrl (added for mobile responsiveness)
  yext.imageloader.$selectAFile = yext.imageloader.$container.find('.js-select-file');
  yext.imageloader.$enterAUrl = yext.imageloader.$container.find('.js-enter-a-url');
  yext.imageloader.$externalImageForm = yext.imageloader.$container.find('.js-external-image-form');
  yext.imageloader.$externalImageUrl = yext.imageloader.$externalImageForm.find('.js-external-image-url');
  yext.imageloader.$externalImageCancel = yext.imageloader.$externalImageForm.find('.js-external-image-cancel');
  yext.imageloader.$form = yext.imageloader.$container.find('form');
  yext.imageloader.$photoErrors = $('.js-photo-errors');
  yext.imageloader.$dropAreaConstraints = yext.imageloader.$dropArea.find('.js-drop-area-constraints');
  yext.imageloader.fileSelector = yext.fileupload.fileSelector();
  yext.imageloader.fileSelector.targetElement(yext.imageloader.$selectAFile);

  yext.imageloader.externalImageUrlEndpoint = yext.imageloader.options.externalImageUrlEndpoint;

  yext.imageloader.files = [];
  yext.imageloader.uploadEndpoint = yext.imageloader.options.uploadEndpoint;
  yext.imageloader.supportsLocalImages = true;

  if (options.alwaysUploadPhoto) {
    yext.imageloader.supportsLocalImages = false;
  }

  yext.imageloader.configureWithOptions();

  yext.imageloader.spinner = new Spinner({
    length: 12,
    width: 3,
    radius: 9,
    color: '#000',
    hwaccel: true,
  });

  yext.imageloader.chooseFileInputType();
  yext.imageloader.bindInitialHandlers();
  yext.imageloader.bindSelectFileUrl();
  yext.imageloader.bindEnterUrl();
  yext.imageloader.initialize();
};

/**
 * To support multiple use cases, two file inputs are initially rendered in the
 * image loader html. When in an older IE browser the 'fallback-upload-area'
 * will be used so the other should be removed and vice versa.
 */
yext.imageloader.chooseFileInputType = function() {
  var $fallback = yext.imageloader.$container.find('.js-fallback-upload-area');
  if ($fallback.css('display') === 'none') {
    $fallback.remove();
  } else {
    yext.imageloader.$container.find('.js-select-file-or-url').remove();
  }
};

/**
 * Bind default image loader handlers
 */
yext.imageloader.bindInitialHandlers = function() {
  yext.imageloader.$container.on('fileuploaddragover', function() {
    yext.imageloader.$dropArea.addClass('drag-over');
  });

  $(document).bind('dragover', function(e) {
    if ($(e.target).closest(yext.imageloader.$dropArea).length === 0) {
      yext.imageloader.$dropArea.removeClass('drag-over');
    }
  });

  yext.imageloader.$container.on('fileuploaddrop', function() {
    yext.imageloader.$dropArea.removeClass('drag-over');
  });
};

/**
 * Bind handlers for the "select a file or enter a URL" buttons
 */
yext.imageloader.bindSelectFileUrl = function() {
  yext.imageloader.$selectAFile.click(function() {
    yext.imageloader.$photoErrors.hide();
  });

  yext.imageloader.$enterAUrl.click(function() {
    yext.imageloader.$photoErrors.hide();
    yext.imageloader.$selectFileOrUrl.hide();
    yext.imageloader.$externalImageForm.show();
    yext.imageloader.$externalImageUrl.focus();
  });
};

/**
 * Bind events for adding an image by external url
 */
yext.imageloader.bindEnterUrl = function() {
  var keyUpTimeout;

  yext.imageloader.$externalImageCancel.click(function() {
    clearTimeout(keyUpTimeout);
    yext.imageloader.renderDefaults();
    yext.imageloader.fetchImageXhr && yext.imageloader.fetchImageXhr.abort();
  });

  yext.imageloader.$externalImageUrl.blur(function() {
    clearTimeout(keyUpTimeout);
    yext.imageloader.fetchImageByUrl();
  });

  yext.imageloader.$externalImageUrl.keyup(function() {
    clearTimeout(keyUpTimeout);
    keyUpTimeout = setTimeout(function() {
      yext.imageloader.fetchImageByUrl();
    }, yext.imageloader.externalImageUrlTimeout);
  });

  yext.imageloader.$externalImageForm.submit(function() {
    clearTimeout(keyUpTimeout);
    yext.imageloader.fetchImageByUrl();
    return false;
  });
};

/**
 * Initialize fileupload plugin
 */
yext.imageloader.initialize = function() {
  yext.imageloader.$container.fileupload({
    forceIframeTransport: false,
    acceptFileTypes: yext.imageloader.options.acceptedFileTypes,
    maxFileSize: yext.imageloader.maxFileSize,
    singleFileUploads: false,
    multipart: true,
    dropZone: yext.imageloader.$dropArea,
    add: function(e, data) {
      if (data.files.length == 0) {
        var error = {};
        error.message = yext.msg('Cannot retrieve the file you selected. Please select a new image and try again.');
        yext.imageloader.onError({error: error});
      } else {
        var tooLarge = false;
        var tooSmall = false;
        $.each(data.files, function(index, file) {
          if (file.size > yext.imageloader.maxFileSize * 1024 * 1024) {
            tooLarge = true;
          } else if (file.size < yext.imageloader.minFileSize) {
            tooSmall = true;
          }
        });

        if (tooLarge || tooSmall) {
          var error = {};
          if (tooLarge) {
            error.message = yext.msg('The file you selected is too large. The maximum image size is {0} MB. Please select a new image and try again.', yext.imageloader.maxFileSize);
          } else {
            error.message = yext.msg('The file you selected is too small. The minimum image size is {0} Bytes. Please select a new image and try again.', yext.imageloader.minFileSize);
          }
          yext.imageloader.onError({error: error});
        } else {
          yext.imageloader.files = data.files;
          yext.imageloader.doAdd(data);
        }
      }
    },
    dataType: 'iframejson',
    converters: yext.fileuploadIframeConverters,
    start: function(e) {
      yext.imageloader.onStart();
    },
    done: function(e, data) {
      if (data.result.error) {
        yext.imageloader.onError({error: data.result.error});
      } else if (data.result.html) {
        yext.imageloader.onSend(data.result.html);
      } else {
        yext.imageloader.onSend(data.result.imageUrl, data.result.imageWidth, data.result.imageHeight);
      }
    },
    progress: function(e, data) {
      yext.imageloader.onProgress(data.loaded, data.total);
    },
    fail: function(e, data) {
      yext.imageloader.onError(data);
    },
  });
};

/**
 * Publish 'add' event
 */
yext.imageloader.onAdd = function() {
  yext.imageloader.resetImageOptions();
  $(yext.imageloader.events).trigger('add.imageloader', arguments);
};

/**
 * Publish 'send' event
 */
yext.imageloader.onSend = function() {
  $(yext.imageloader.events).trigger('send.imageloader', arguments);
};

/**
 * Publish 'error' event
 */
yext.imageloader.onError = function(data) {
  if (data.error && data.error.message) {
    yext.imageloader.$photoErrors
      .html(data.error.message)
      .show();
  }
  $(yext.imageloader.events).trigger('error.imageloader', data);
};

/**
 * Publish 'start' event
 */
yext.imageloader.onStart = function() {
  $(yext.imageloader.events).trigger('start.imageloader', arguments);
};

/**
 * Publish 'progress' event
 */
yext.imageloader.onProgress = function() {
  $(yext.imageloader.events).trigger('progress.imageloader', arguments);
};

/**
 * Upload the image to the server
 */
yext.imageloader.doSend = function() {
  yext.imageloader.$container.fileupload('send', {
    url: yext.imageloader.uploadEndpoint,
    files: yext.imageloader.files,
    form: yext.imageloader.$form,
  });
};

/**
 * Loads a file locally for display and then triggers the onAdd callback. If
 * local images are not supported, image is uploaded to server as fallback
 */
yext.imageloader.doAdd = function(data) {
  // TODO(mattjs) Investigate - logic seems off for multiple file add at once
  $.each(data.files, function(index, file) {
    if (file.type && !yext.imageloader.options.acceptedFileTypes.test(file.type)) {
      var error = {};
      error.message = yext.imageloader.options.badFileTypeMsg;
      yext.imageloader.onError({error: error});
    } else {
      if (yext.imageloader.supportsLocalImages) {
        yext.imageloader.loadLocalPhoto(file, function(url) {
          if (url) {
            var image = {
              url: url,
              fileName: file['name'],
              file: file,
            };

            if (data.fileInput) {
              image.fileInput = data.fileInput[0];
            }

            yext.imageloader.checkDimensionConstraints(
              url,
              function() {
                yext.imageloader.onAdd(image);
              },
              yext.imageloader.showInvalidDimensionsError,
            );
          } else {
            yext.imageloader.supportsLocalImages = false;
            yext.imageloader.addFallback(data);
          }
        });
      } else {
        yext.imageloader.addFallback(data);
      }
    }
  });
};

/**
 * Fallback for browsers that do not support local images. Uploads the image
 * to the server and triggers both onAdd and onSend because image will not
 * need to be uploaded again
 */
yext.imageloader.addFallback = function(data) {
  var timeout = yext.dialog.showDelayedProgressDialog(yext.msg('Image uploading ...'));

  yext.imageloader.$container.fileupload({
    url: yext.imageloader.uploadEndpoint,
    // Unwrapping HTML-encoded JSON required for IE's iframe transport.
    dataType: 'iframejson',
    converters: yext.fileuploadIframeConverters,
    done: function(e, data) {
      yext.dialog.hideDelayedProgressDialog(timeout);
      if (data.result.error) {
        yext.imageloader.onError({error: data.result.error});
      } else {
        if (data.result.html) {
          yext.imageloader.onSend(data.result.html);
        } else {
          var dimensionsError = yext.image.getDimensionsError(
            yext.imageloader.options.constraints,
            {
              width: data.result.imageWidth,
              height: data.result.imageHeight,
            },
          );
          if (!dimensionsError) {
            yext.imageloader.onAdd({
              url: data.result.imageUrl,
              fileName: data.files[0]['name'],
            });
            yext.imageloader.onSend(data.result.imageUrl, data.result.imageWidth, data.result.imageHeight);
          } else {
            yext.imageloader.showInvalidDimensionsError(dimensionsError);
          }
        }
      }
    },
    fail: function(e, data) {
      yext.dialog.hideDelayedProgressDialog(timeout);
      yext.imageloader.onError(data);
    },
  });

  var fileInputs = [];
  if (data.fileInput && data.fileInput.length > 0) {
    fileInputs.push(data.fileInput[0]);
  }

  // TODO(mattjs) Remove this once DAM upload popup is added
  if (yext.imageloader.options.imageType) {
    yext.imageloader.$form.find('input[name=imageType]').val(yext.imageloader.options.imageType);
  }

  yext.imageloader.$container.fileupload('send', {
    files: data.files,
    paramName: 'file',
    fileInput: fileInputs,
    form: yext.imageloader.$form,
  });
};

/**
 * Looks for a url API and returns false if unsuccessful
 */
yext.imageloader.createObjectURL = function(file) {
  var urlAPI = window.createObjectURL || window.URL || window.webkitURL;
  return urlAPI ? urlAPI.createObjectURL(file) : false;
};

/**
 * Read local files using HTML5 FileReader API
 */
yext.imageloader.loadFile = function(file, callback) {
  if (typeof FileReader !== 'undefined' && FileReader.prototype.readAsDataURL) {
    var fileReader = new FileReader();
    fileReader.onload = function(e) {
      callback(e.target.result);
    };
    fileReader.readAsDataURL(file);
  } else {
    callback(false);
  }
};

/**
 * Trys to load a photo locally using createObjectURL or FileReader API
 */
yext.imageloader.loadLocalPhoto = function(file, callback) {
  var url = yext.imageloader.createObjectURL(file);
  if (url) {
    callback(url);
  } else {
    yext.imageloader.loadFile(file, callback);
  }
};

/**
 * Hides the external url form and shows the default options
 */
yext.imageloader.resetImageOptions = function() {
  yext.imageloader.renderDefaults();
  yext.imageloader.options.constraints = yext.imageloader.defaultOptions.constraints;
  yext.imageloader.updateConstraintsMessage();
};

/**
 * Hides the external url form
 */
yext.imageloader.renderDefaults = function() {
  yext.imageloader.$externalImageForm.hide();
  yext.imageloader.$selectFileOrUrl.show();
  yext.imageloader.$externalImageUrl.val('').removeAttr('disabled');
  yext.imageloader.toggleDropArea(true);
  yext.imageloader.$photoErrors.val('').hide();
};

/**
 * hides the enter a url option
 */
yext.imageloader.hideUrlOption = function() {
  yext.imageloader.$enterAUrl.hide();
  yext.imageloader.$selectFileOrUrl.find('.js-select-file-or').hide();
};

/**
 * Shows the enter a url option
 */
yext.imageloader.showUrlOption = function() {
  yext.imageloader.$enterAUrl.show();
  yext.imageloader.$selectFileOrUrl.find('.js-select-file-or').show();
};

/**
 * Update configuration using given options
 * @param {!Object} options the new set of options
 */
yext.imageloader.updateOptions = function(options) {
  yext.imageloader.options = $.extend(true, {}, yext.imageloader.options, options);
  yext.imageloader.configureWithOptions();
};

/**
 * Configure the imageloader using options
 */
yext.imageloader.configureWithOptions = function() {
  yext.imageloader.maxFileSize = yext.imageloader.options.constraints.maxFileSize;
  yext.imageloader.minFileSize = yext.imageloader.options.constraints.minFileSize;
  yext.imageloader.updateConstraintsMessage();
};

/**
 * shows the max size, min size, min height and min width dimensions if there are constraints
 */
yext.imageloader.updateConstraintsMessage = function() {
  var constraints = yext.imageloader.options.constraints;
  var minDimensionsMessage = '';
  var maxDimensionsMessage = '';

  if (constraints.height
      && constraints.height > yext.image.Constraints.defaults.height
      && constraints.width
      && constraints.width > yext.image.Constraints.defaults.width) {
    minDimensionsMessage = yext.msg('Minimum Dimensions: {0}px wide by {1}px tall', constraints.width, constraints.height);
  } else if (constraints.width
             && constraints.width > yext.image.Constraints.defaults.width) {
    minDimensionsMessage = yext.msg('Minimum Dimension: {0}px wide', constraints.width);
  } else if (constraints.height
              && constraints.height > yext.image.Constraints.defaults.height) {
    minDimensionsMessage = yext.msg('Minimum Dimension: {0}px tall', constraints.height);
  }
  yext.imageloader.$dropAreaConstraints.find('.js-dimensions').html(minDimensionsMessage);

  if (constraints.maxHeight && constraints.maxWidth) {
    maxDimensionsMessage = yext.msg('Maximum Dimensions: {0}px wide by {1}px tall', constraints.maxWidth, constraints.maxHeight);
  } else if (constraints.maxHeight) {
    maxDimensionsMessage = yext.msg('Maximum Dimension: {0}px wide', constraints.maxWidth);
  } else if (constraints.maxWidth) {
    maxDimensionsMessage = yext.msg('Maximum Dimension: {0}px tall', constraints.maxHeight);
  }
  yext.imageloader.$dropAreaConstraints.find('.js-max-dimensions').html(maxDimensionsMessage);

  if (constraints.maxFileSize) {
    yext.imageloader.$dropAreaConstraints.find('.js-max-file-size')
      .html(yext.msg('Maximum file size: {0}MB', constraints.maxFileSize));
  } else {
    yext.imageloader.$dropAreaConstraints.find('.js-max-file-size').html('');
  }

  if (constraints.minFileSize && constraints.minFileSize > yext.image.Constraints.defaults.minFileSize) {
    yext.imageloader.$dropAreaConstraints.find('.js-min-file-size')
      .html(yext.msg('Minimum file size: {0} Bytes', constraints.minFileSize));
  } else {
    yext.imageloader.$dropAreaConstraints.find('.js-min-file-size').html('');
  }
};

/**
 * Show error message displaying the violated constraints
 *
 * @param {string} error identifier from yext.image
 */
yext.imageloader.showInvalidDimensionsError = function(error) {
  var message;
  var constraints = yext.imageloader.options.constraints;

  if (yext.image.MIN_DIMENSIONS_ERROR == error) {
    if (constraints.height && constraints.width) {
      message = yext.msg(
        'Please choose an image that\'s at least {0} pixels wide and at least {1} pixels tall.',
        constraints.width,
        constraints.height);
    } else if (constraints.height) {
      message = yext.msg('Please choose an image that\'s at least {0} pixels tall.', constraints.height);
    } else if (constraints.width) {
      message = yext.msg('Please choose an image that\'s at least {0} pixels wide.', constraints.width);
    }
  } else if (yext.image.MAX_DIMENSIONS_ERROR == error) {
    if (constraints.maxWidth && constraints.maxHeight) {
      message = yext.msg(
        'Please choose an image that\'s at most {0} pixels wide and at most {1} pixels tall.',
        constraints.maxWidth,
        constraints.maxHeight);
    } else if (constraints.maxHeight) {
      message = yext.msg('Please choose an image that\'s at most {0} pixels tall.', constraints.maxHeight);
    } else if (constraints.maxWidth) {
      message = yext.msg('Please choose an image that\'s at most {0} pixels wide.', constraints.maxWidth);
    }
  } else if (yext.image.MAX_PIXELS_ERROR == error) {
    message = yext.msg('Please choose an image that\'s at most {0} total pixels.', constraints.maxPixels);
  }
  yext.imageloader.onError({
    error: {
      message: message,
    },
  });
};

/**
 * @param  {boolean} shouldDisplay if true show the droparea items if false hide them
 */
yext.imageloader.toggleDropArea = function(shouldDisplay) {
  yext.imageloader.$dropImageIcon.toggle(shouldDisplay);
  yext.imageloader.$dropAreaMessage.toggle(shouldDisplay);
};

/**
 * Fetch external image by url
 */
yext.imageloader.fetchImageByUrl = function() {
  if (!yext.imageloader.fetchImageByUrlMutex) {
    var url = yext.imageloader.$externalImageUrl.val().trim();

    if (url) {
      yext.imageloader.fetchImageByUrlMutex = true;
      yext.imageloader.$externalImageUrl.val(url);
      yext.imageloader.toggleDropArea(false); // hide droparea
      var data = yext.imageloader.$externalImageForm.serialize();
      yext.imageloader.$externalImageUrl.attr('disabled', 'disabled');

      yext.imageloader.spinner.spin(yext.imageloader.$dropArea[0]);

      yext.imageloader.fetchImageXhr = $.ajax({
        url: yext.imageloader.externalImageUrlEndpoint,
        data: data,
        success: function(response) {
          yext.imageloader.spinner.stop();
          if (response.html) {
            yext.imageloader.onSend(response.html);
          } else if (response.error) {
            yext.imageloader.$photoErrors
              .html(response.error.message)
              .show();
            yext.imageloader.toggleDropArea(true);
            yext.imageloader.$externalImageUrl.removeAttr('disabled');
          } else {
            yext.imageloader.checkDimensionConstraints(
              response.imageUrl,
              function() {
                yext.imageloader.files = [];
                yext.imageloader.onAdd({
                  url: response.imageUrl,
                  fileName: url.replace(/^.*[\\\/]/, ''),
                  sourceUrl: url,
                });
                yext.imageloader.onSend(response.imageUrl, response.imageWidth, response.imageHeight);
              },
              function(error) {
                yext.imageloader.showInvalidDimensionsError(error);
                yext.imageloader.toggleDropArea(true);
              },
            );
          }
          yext.imageloader.fetchImageByUrlMutex = false;
        },
        error: function() {
          yext.imageloader.spinner.stop();
          // TODO(mattjs) Error handling
          yext.imageloader.fetchImageByUrlMutex = false;
        },
        type: 'POST',
      });
    }
  }
};

/**
 * Check image dimensions if provided
 *
 * @param {string} url
 * @param {function()} successCallback Callback triggered when image dimensions are valid
 * @param {function()} failCallback Callback triggered when image dimensions are invalid
 */
yext.imageloader.checkDimensionConstraints = function(url, successCallback, failCallback) {
  if (!yext.isFunction(successCallback) || !yext.isFunction(failCallback)) {
    throw new TypeError('imageloader: Unable to check dimension constraints');
  }
  if (!yext.imageloader.options.constraints.width
      && !yext.imageloader.options.constraints.height
      && !yext.imageloader.options.constraints.maxWidth
      && !yext.imageloader.options.constraints.maxHeight) {
    successCallback();
  } else {
    yext.image.getImageDimensions(
      url,
      function(imageDimensions) {
        var error = yext.image.getDimensionsError(yext.imageloader.options.constraints, imageDimensions);
        if (!error) {
          successCallback();
        } else {
          failCallback(error);
        }
      },
    );
  }
};
